module.exports = __webpack_public_path__ + "img/heading-bg-dark.a51dbaca.svg";